export const AppRoutes = {
  home: () => '/project/edit/:proposalId',
  // Org-first, matching the Next dashboard's [org]/... convention. The from-scratch agent flow
  // has no resource to derive the org from, so the acting org is named in the URL by the caller.
  documentAgent: (orgId?: string | number) =>
    `/${orgId !== undefined ? orgId : ':orgId'}/project/agent`,
  figmaServicesPreview: () => '/figma-preview/services',
  pageNotFound: () => '/page-not-found',
  proposalNotFound: () => '/proposal-not-found',
  passwordDocumentRecipientView: (hash?: string) =>
    `/document-password/${hash !== undefined ? hash : ':hash'}`,
  documentExpired: (documentId?: string) =>
    `/document-expired/${documentId !== undefined ? documentId : ':hash'}`,
  preview: (documentId?: string) =>
    `/project/preview/${documentId !== undefined ? documentId : ':proposalId'}`,
  view: (documentId?: string) => `/project/view/${documentId !== undefined ? documentId : ':hash'}`,
  share: (documentId?: string) => `/view/${documentId !== undefined ? documentId : ':hash'}`,
  templatePreview: (documentId?: string) =>
    `/template-preview/${documentId !== undefined ? documentId : ':templateHash'}`,
  testPreview: () => '/test-preview',
  simpleJsonPlayground: () => '/simple-json-playground',
  export: () => '/export',
};

// The agent route's org segment is variable, so route checks match the stable suffix.
export const isDocumentAgentPath = (pathname: string): boolean =>
  /\/project\/agent$/.test(pathname);

// The guest app serves the agent at the org-less /project/agent; the authed builder needs the org
// in the path. A logged-in visitor following a guest link lands on the bare path, which no authed
// route claims, so it must be redirected rather than left to the 404 splat.
export const isBareDocumentAgentPath = (pathname: string): boolean =>
  /^\/project\/agent\/?$/.test(pathname);

const EDIT_PROPOSAL_PREFIX = '/project/edit/';

export const getEditProposalIdFromPath = (pathname: string): string | null => {
  if (!pathname.startsWith(EDIT_PROPOSAL_PREFIX)) return null;
  const proposalId = pathname.slice(EDIT_PROPOSAL_PREFIX.length).split('/')[0];
  return proposalId || null;
};
